export default __webpack_public_path__ + "static/media/Roobert-Italic.4b79aa89.woff";